import S from "./ghl-ui.es405.js";
import h from "./ghl-ui.es406.js";
import W from "./ghl-ui.es407.js";
var y = "Expected a function", R = Math.max, A = Math.min;
function _(x, i, u) {
  var a, d, c, f, n, r, l = 0, E = !1, m = !1, g = !0;
  if (typeof x != "function")
    throw new TypeError(y);
  i = W(i) || 0, S(u) && (E = !!u.leading, m = "maxWait" in u, c = m ? R(W(u.maxWait) || 0, i) : c, g = "trailing" in u ? !!u.trailing : g);
  function v(e) {
    var t = a, o = d;
    return a = d = void 0, l = e, f = x.apply(o, t), f;
  }
  function b(e) {
    return l = e, n = setTimeout(s, i), E ? v(e) : f;
  }
  function C(e) {
    var t = e - r, o = e - l, p = i - t;
    return m ? A(p, c - o) : p;
  }
  function k(e) {
    var t = e - r, o = e - l;
    return r === void 0 || t >= i || t < 0 || m && o >= c;
  }
  function s() {
    var e = h();
    if (k(e))
      return I(e);
    n = setTimeout(s, C(e));
  }
  function I(e) {
    return n = void 0, g && a ? v(e) : (a = d = void 0, f);
  }
  function L() {
    n !== void 0 && clearTimeout(n), l = 0, a = r = d = n = void 0;
  }
  function M() {
    return n === void 0 ? f : I(h());
  }
  function T() {
    var e = h(), t = k(e);
    if (a = arguments, d = this, r = e, t) {
      if (n === void 0)
        return b(r);
      if (m)
        return clearTimeout(n), n = setTimeout(s, i), v(r);
    }
    return n === void 0 && (n = setTimeout(s, i)), f;
  }
  return T.cancel = L, T.flush = M, T;
}
export {
  _ as default
};
